/**
 * Slider evaluation component.
 */

import { ApplicationContext } from '../../common/context';
import { Button, Form, Input, InputNumber, Popconfirm, Radio } from 'antd';
import { FormattedMessage, useIntl } from "react-intl";
import { number } from 'prop-types';
import React, { useContext, useEffect } from 'react';

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

const SlickEvaluate = props => {
  const { id } = props;

  const context = useContext(ApplicationContext);
  const prefix = context.isMatrix ? 'matrix' : 'evaluation';
  const title = context.getOption(`${prefix}.form[${id}][0]`, null);
  const project = context.getOption(`${prefix}.form`, null);
  const getProjectAnswers = context.getOption(`${prefix}.form[${id}]`, null);
  const projectValue = context.getOption(`${prefix}.form[${id}][1]`, null);
  const totalSectionA = context.getOption(`${prefix}.totals[${id}]`, null);

  const isChecked = (position, compareWith) => {
    const value = context.getOption(`${prefix}.form[${id}][${position}]`);

    return value === compareWith;
  };

  const totalResult = item => {
    let value = null;

    if (item === 7) {
      value = totalSectionA[0];
    } else if (item === 14) {
      value = totalSectionA[1];
    }

    return value;
  };

  useEffect(() => {
    context.handleSetAvaliationForm(id, props.form);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.form]);

  const collection = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];

  const { form: { getFieldDecorator } } = props;

  return (

    <div className={'swiper-slide-evaluate'}>
      <div className={'swiper-slide__header'}>
        {
          project.length === 1 ? <div /> : <Popconfirm
            cancelText={<FormattedMessage id="slick.no"/>}
            okText={<FormattedMessage id="slick.yes"/>}
            okType={'tertiary'}
            onConfirm={() => context.removeColumn(id)}
            placement={'right'}
            title={<FormattedMessage id="slick.deleteConfirm"/>}
          // eslint-disable-next-line react/jsx-closing-bracket-location
          >
            <Button
              className={'swiper-slide__remove-btn'}
              type={'light'}
            >
              <FormattedMessage id="slick.delete"/>
            </Button>
          </Popconfirm>
        }

        <Form.Item>
          {getFieldDecorator(`title`, {
            initialValue: title,
            rules: [{ message: <FormattedMessage id="slick.required"/>, required: true }]
          })(
            <Input
              onChange={event => context.addProjectAnswer(event.target, id, 0)}
              placeholder={useIntl().formatMessage({ id: 'slick.name' })}
              value={title}
            />
          )}
        </Form.Item>

        <Form.Item>
          {getFieldDecorator(`value`, {
            initialValue: projectValue,
            rules: [{ message: <FormattedMessage id="slick.required"/>, required: true }]
          })(
            <InputNumber
              formatter={value => `${value}€`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
              min={0}
              onChange={value => {
                if (Number.isInteger(value) && Number(value) > 0) {
                  context.addProjectAnswer(value, id, 1);
                }
              }}
              parser={value => value.replace(/€\s?|(\.*)/g, '')}
              style={{
                height: '40px',
                marginTop: 8,
                padding: '4px',
                textAlign: 'right',
                width: '100%'
              }}
              value={projectValue}
            />)
          }
        </Form.Item>
      </div>

      <div className={'swiper-slide__body'}>
        <div className={'swiper-slide__spacer swiper-slide__spacer--one'}>
          <p className={'swiper-slide__legend'}>
            <FormattedMessage id="slick.evaluation.legend1"/>
          </p>

          <p className={'swiper-slide__legend'}>
          <FormattedMessage id="slick.evaluation.legend2"/>
          </p>

          <p className={'swiper-slide__legend'}>
            <FormattedMessage id="slick.evaluation.legend3"/>
          </p>
        </div>

        <Form >
          {collection.map((item, index) => (
            <div
              className={'swiper-slide__answer-wrapper'}
              key={item}
            >
              <div className={'swiper-slide__answer'}>
                <Form.Item>
                  {getFieldDecorator(`answer${index}`, {
                    initialValue: getProjectAnswers[item],
                    rules: [{ message: <FormattedMessage id="slick.required"/>, required: true }]
                  })(
                    <RadioGroup>
                      <RadioButton
                        checked={isChecked(item, 1)}
                        className={'swiper-slide__answer-option'}
                        onChange={event => {
                          context.addProjectAnswer(event.target, id, item);
                        }}
                        value={1}
                      >
                        {'1'}
                      </RadioButton>

                      <RadioButton
                        checked={isChecked(item, 2)}
                        className={'swiper-slide__answer-option'}
                        onChange={event => {
                          context.addProjectAnswer(event.target, id, item);
                        }}
                        value={2}
                      >
                        {'2'}
                      </RadioButton>

                      <RadioButton
                        checked={isChecked(item, 3)}
                        className={'swiper-slide__answer-option'}
                        onChange={event => {
                          context.addProjectAnswer(event.target, id, item);
                        }}
                        value={3}
                      >
                        {'3'}
                      </RadioButton>
                    </RadioGroup>)}
                </Form.Item>
              </div>

              {item === 7 || item === 14 ? (<div className={'swiper-slide__pontuation'}>{totalResult(item)}</div>) : null}

              {item === 4 ? (<div className={'swiper-slide__spacer swiper-slide__spacer--two'}>
                <h6 className={'swiper-slide__legend'}>
                  <FormattedMessage id="slick.evaluation.legend4"/>
                </h6>

                <h6 className={'swiper-slide__legend'}>
                  <FormattedMessage id="slick.evaluation.legend5"/>
                </h6>

                <h6 className={'swiper-slide__legend'}>
                  <FormattedMessage id="slick.evaluation.legend6"/>
                </h6>
              </div>) : null}

              {item === 7 ? (<div className={'swiper-slide__spacer swiper-slide__spacer--three'}>
                <h6 className={'swiper-slide__legend'}>
                  <FormattedMessage id="slick.evaluation.legend7"/>
                </h6>

                <h6 className={'swiper-slide__legend'}>
                  <FormattedMessage id="slick.evaluation.legend8"/>
                </h6>

                <h6 className={'swiper-slide__legend'}>
                  <FormattedMessage id="slick.evaluation.legend9"/>
                </h6>
              </div>) : null}

              {item === 11 ? (<div className={'swiper-slide__spacer swiper-slide__spacer--four'}>
                <h6 className={'swiper-slide__legend'}>
                  <FormattedMessage id="slick.evaluation.legend10"/>
                </h6>

                <h6 className={'swiper-slide__legend'}>
                  <FormattedMessage id="slick.evaluation.legend11"/>
                </h6>

                <h6 className={'swiper-slide__legend'}>
                  <FormattedMessage id="slick.evaluation.legend12"/>
                </h6>
              </div>) : null}
            </div>
          ))}
        </Form>
      </div>
    </div>
  );
};

SlickEvaluate.propTypes = {
  id: number.isRequired
};

export default Form.create()(SlickEvaluate);
